<template>
  <div
    :class="getContainerClasses"
    class="select-none"
  >
    <div
      type="button"
      :class="getClasses"
      class="flex items-center justify-center leading-5 shadow-sm border border-transparent
      text-sm font-medium rounded-md  focus:outline-none focus:shadow-outline-indigo transition ease-in-out
      duration-150"
      @click="emitClick"
    >
      <div v-if="!loading">
        <i
          v-if="icon !== ''"
          :class="icon"
          class="mr-1"
        />
        {{ text }}
      </div>
      <div
        v-else
        class="-mt-1"
      >
        <LoadingSpinner :white="true" />
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';

export default {

  components: {
    LoadingSpinner,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    widthFull: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    getContainerClasses() {
      let classes = '';

      if (this.widthFull) {
        classes += 'w-full min-w-full ';
      }

      return classes;
    },

    getClasses() {
      let classes = '';

      if (this.widthFull) {
        classes += 'w-full min-w-full ';
      }

      if (this.disabled) {
        classes += 'bg-gray-100 border-gray-200 text-gray-500 ';
      } else {
        classes += 'bg-gray-700 hover:bg-gray-600 active:bg-gray-600 focus:border-gray-700 text-white cursor-pointer ';
      }

      if (this.padding !== undefined) {
        classes += `${this.padding} `;
      } else {
        classes += 'px-3 py-2 ';
      }

      return classes;
    },
  },

  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>
